export default __webpack_public_path__ + "e8fc218.png";